export enum EFSExperienceId {
  FirstTime = 60720,
  Experienced = 60721
}
